import React from 'react'
import { Route, Routes } from 'react-router-dom'
import BhutaniCityCenter from './BhutaniCityCenter'
import ConventionalCenter from './pages/ConvestionalCenter'
import GreenOffice from './pages/GreenOffice'
import Wellness from './pages/Wellness'
import Apartments from './pages/Apartments'
import Restaurants from './pages/Restaurants'
import FoodCourt from './pages/FoodCourt'

const BhutaniContext = () => {
    return (<>
        <Routes>
            <Route path="/conventional-center" element={<ConventionalCenter />} />
            <Route path="/green-office" element={<GreenOffice />} />
            <Route path="/wellness" element={<Wellness />} />
            <Route path="/apartments" element={<Apartments />} />
            <Route path="/food-court" element={<FoodCourt />} />
            <Route path="/restaurants" element={<Restaurants />} />
        </Routes>
    </>
    )
}
export default BhutaniContext